var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"welcome-section"},[_c('h1',{staticClass:"welcome-title heading-3"},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Hey {userName}!', { userName: _vm.userName }))+"\n  ")]),_c('p',{staticClass:"welcome-message"},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Get your audience talking—start with the right slide.'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }